import EmailWhitelabelingSuccess from "./EmailWhitelabelingSuccess";

export default EmailWhitelabelingSuccess;